export default "__VITE_ASSET__D5vN_8xA__"